import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDEmphasisSurface,
  FDIcon,
  FDStack, FDTitleText,
} from '@facet-wealth/design';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { getBorder, getBorderRadius } from 'Components/utils';
import { metaOverrideSet } from './metaOverrideSet';

const useStyles = buildUseStyles('GuidedHouseholdReviewIntroLayout', (theme) => ({
  relativeRoot: {
    position: 'relative',
  },
  circle: {
    background: theme.palette.common.white,
    ...getBorder(theme, { all: true, color: theme.palette.facet.oceana500, width: 6 }),
    ...getBorderRadius(theme.radius.full, { all: true }),
    padding: theme.spacing(3),
  },
  connector: {
    marginTop: theme.spacing(8),
    width: 100,
    height: 0,
    ...getBorder(theme, { all: true, color: theme.palette.facet.oceana500, width: 3 }),
    // Move inwards a bit so that there isn't a gap between the line and the curvature of the circle
    marginLeft: -1,
    marginRight: -1,
  },
  number: {
    position: 'absolute',
    top: 0,
    right: 0,
    ...getBorderRadius(theme.radius.full, { all: true }),
    overflow: 'hidden', // Force border-radius onto child
    width: theme.spacing(5),
    height: theme.spacing(5),
    display: 'flex',
  },
  name: {
    position: 'absolute',
    width: '200px',
    left: theme.spacing(-4),
    bottom: `calc(-50% - ${theme.spacing(1)}px)`,
  },
}));

export const GuidedHouseholdReviewIntroLayout = () => {
  const classes = useStyles();
  const { resource } = useMetaLayoutContext();
  const components = resource.attr('components').resources().list();
  return (
    <>
      <FDStack direction="row" justifyContent="center" paddingY={4}>
        {components.map((component, i) => (
          <>
            <FDStack direction="column" spacing={2} justifyContent="flex-start" alignItems="center">
              <div className={classes.relativeRoot}>
                <div className={classes.circle}>
                  <FDIcon icon={component.attr('icon')} size="xl" color="secondary" />
                </div>
                <div className={classes.number}>
                  <FDEmphasisSurface flex={1}>
                    <FDStack justifyContent="center" alignItems="center" height="100%">
                      <FDTitleText value={i + 1} align="center" size="lg" />
                    </FDStack>
                  </FDEmphasisSurface>
                </div>
                <div className={classes.name}>
                  <MetaControl resource={component} attrName="name" metaOverrideSet={metaOverrideSet} />
                </div>
              </div>
            </FDStack>
            {i + 1 < components.length ? <div className={classes.connector} /> : null}
          </>
        ))}
      </FDStack>
      <FDStack paddingY={2} />{/* Make up for the position:absolute text */}
    </>
  );
};
